import * as React from 'react';
import { runwayColors } from './styles/globalStyles';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import Layout from 'antd/lib/layout/layout';
import Result from 'antd/lib/result';
import { useThemeMode } from './styles/themeMode';

interface EntityNotFoundComponentProps {
    entityType: string;
}

const EntityNotFoundComponent = (props: EntityNotFoundComponentProps) => {
    const { mode } = useThemeMode();
    const isDarkMode = mode === 'dark';

    return (
        <Layout style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Result
                title={`${props.entityType} not found.`}
                icon={
                    <QuestionCircleTwoTone
                        twoToneColor={isDarkMode ? [runwayColors.statusGrey, 'transparent'] : runwayColors.statusGrey}
                    />
                }
            />
        </Layout>
    );
};

export default EntityNotFoundComponent;
